<template>
  <div class="elevation-1 mt-2">
    <v-card>
      <OperationalScreen_QuadrantToolbar
        v-if="properties.showToolbar"
        fixed
        :componentId="properties.componentId"
        :headers="headers"
        :title="properties.tag"
        :mainMap="properties.mainMap"
        :toolBarOptions="true"
      >
        <!-- <slot class="settings_css" name="settingContent"> -->
        <template slot="settingContent">
          <v-card-title>{{$translate('SELECT_SIGNALS')}}</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px;">
            <v-card class="elevation-0 settingContentCard">
              <div v-for="(el, i) in signalsList" :key="i">
                <v-checkbox v-model="el.status" :value="el.name" :label="el.value" />
              </div>
            </v-card>
          </v-card-text>
        </template>
      </OperationalScreen_QuadrantToolbar>
      <!-- getCustomHeight try to add to :class=['map', getCustomHeight ] to give special class css -->

      <div
        :style="properties.height"
        :id="properties.componentId"
        :class="[ 'map' ]"
        @mousemove="mouseOver"
        @click.right.prevent="manageRightClick"
        @click="manageLeftClick"
      />
<!--      <div id="popup" class="ol-popup">-->
<!--        <a href="#" id="popup-closer" class="ol-popup-closer"></a>-->
<!--        <v-layout row>-->
<!--          <img-->
<!--            id="popup-img"-->
<!--            aspect-ratio="1"-->
<!--            class="pa-1 calendarImage"-->
<!--            :src="popupImgSrc"-->
<!--            alt="">-->
<!--          <v-layout column>-->
<!--            <div id="popup-content"></div>-->
<!--          </v-layout>-->
<!--        </v-layout>-->
<!--        <v-layout justify-end align-end>-->
<!--          <v-btn-->
<!--            color="secondary"-->
<!--            round-->
<!--            class="buttonInCarouselDiv text-capitalize"-->
<!--            style="font-size: 15px;"-->
<!--            @click="showEventsOfLocation()"-->
<!--          >{{$translate('VIEW_ACTIVITIES')}}</v-btn>-->
<!--        </v-layout>-->
<!--      </div>-->
    </v-card>
    <!-- <v-layout justify-right v-if="properties.showBackButton">
      <v-btn
        fab
        fixed
        bottom
        right
        color="primary"
        @click="goToMainScreen"
        class="floatingButton"
      >{{$translate('BACK')}}</v-btn>
    </v-layout>-->
    <Tooltip
      v-if="tooltipElement && properties.tooltip !== false"
      :style="tooltipElement.styleObject"
      :rawHtml="tooltipElement.html"
    />
  </div>
</template>
<script>
import * as ol from "openlayers";
import Tooltip from "../Tooltip.vue";
import RelationAspect from "../../aspects/RelationAspect.js";
import BaseRadiusPointAspect from "../../aspects/BaseRadiusPointAspect";
import IncidentAspect from "../../aspects/IncidentAspect.js";
import ParkingFacilityAspect from "../../aspects/ParkingFacilityAspect.js";
import BasePointAspect from "../../aspects/BasePointAspect.js";
import DefaultAspect from "../../aspects/DefaultAspect.js";
import BaseAspect from "../../aspects/BaseAspect.js";
import EntryPointAspect from "../../aspects/EntryPointAspect.js";
import BaseObject from "../../objects/BaseObject";
import appConfig from "../../../config/app_config";
import * as dssRequest from "../../api/dssRequest";
import * as dssUtility from "../../api/DssUtility";
// import * as parser from "../../api/Parser";
import { map_functions } from "../../shared/map_functions.js";
import * as player from "../../shared/player";
import OperationalScreen_BaseQuadrant from "./OperationalScreen_BaseQuadrant";
import OperationalScreen_QuadrantToolbar from "./OperationalScreen_QuadrantToolbar.vue";
import UserAspect from "@/aspects/UserAspect.js";
import LocationAspect from "@/aspects/LocationAspect.js";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "OperationalScreen_MapQuadrant",
  extends: OperationalScreen_BaseQuadrant,
  mixins: [map_functions],
  components: {
    Tooltip,
    OperationalScreen_QuadrantToolbar
  },
  props: {
    propertiesFromIncident: Object
  },
  data() {
    return {
      popupImg: false,
      popupLocationData: "",
      popupImgSrc: "",
      defaultImg: "",
      overlay: {},
      tours: {},
      relays: {},
      vectorLayerWaypoints: {},
      vectorLayerStops: {},
      disableWaypointInteraction: true,
      waypoint: [],
      interactionMap: true,
      zoomControls: true,
      mouseScrollControls: true,
      signalsList: [],
      isDefault: false,
      lastSelectedFeature: "",
      maxAspect: 20,
      currentAspect: 0,
      currentIncident: 0,
      allObjectList: [],
      aspectsListRequested: false,
      center: appConfig.map.center,
      zoom: appConfig.map.zoom,
      tooltipElement: null,
      objectHashMap: Object.create(null),
      polygonInteraction: {},
      drawSource: {},
      drawInteractionLayer: {},
      layerSources: {
        // "key": olSource
      },
      mapLayers: {
        // "key": olLayer
      },
      map: {}, // tha map visible on the screen
      lastMouseTooltip: {} // it stores the last mouse position for tooltip
      // selectAltClick: null
    };
  },
  created() {
    this.headers = ["MAP_TITLE"];
    window.EventBus.listen("clearSource", value => {
      this.clearSource(value);
    });
    window.EventBus.listen("focusOnMarker", this.focusOnMarker);
    window.EventBus.listen("resize", this.resizeComponent);
    window.EventBus.listen("categoriesMarkers", this.categoriesMarkers);
    window.EventBus.listen(
      "transportVehicleUpdate",
      this.transportVehicleUpdate
    );
    window.EventBus.listen("showTours", this.showTours);
    window.EventBus.listen("showRelays", this.showRelays);
    window.EventBus.listen(
      "rightClickSelectBehaviour",
      this.rightClickSelectBehaviour
    );
    window.EventBus.listen("addFeature", this.addFeature);
    window.EventBus.listen("pictureMarkers", this.pictureMarkers);
    window.EventBus.listen(
      "createAspectBasedOnTypeNew",
      this.createAspectBasedOnTypeNew
    );
    window.EventBus.listen("relationStatusUpdate", data => {
      this.relationStatusUpdate(data);
    });
    window.EventBus.listen("aspectUpdate", this.aspectUpdate);
    window.EventBus.listen("clearAllLayers", data => {
      this.clearAllLayers();
    });
    window.EventBus.listen("TO_STATE_UPDATE", this.toStateUpdate);
    window.EventBus.listen("createSegment", segment => {
      this.createSegmentBasedOnType(segment);
    });
    window.EventBus.listen("moveToPreferredArea", interaction => {
      this.moveToPreferredArea();
    });
    window.EventBus.listen("moveToSelectedArea", o => {
      this.putOnMapNew(o.aspect, o.id, o.cleanLayer);
    });
    window.EventBus.listen("moveToFeature", this.moveToFeature);
    window.EventBus.listen("moveToFeature2", this.moveToFeature2);

    window.EventBus.listen("generatePolyline", this.generatePolyline);
    window.EventBus.listen(
      "generateMultiPolylines",
      this.generateMultiPolylines
    );
    window.EventBus.listen("addMarkers", this.addMarkers);
    if (this.properties.clickEvent) {
      window.EventBus.listen(
        "enableWaypointInteraction",
        this.enableWaypointInteraction
      );
    }
    window.EventBus.listen("enableDrawPolyline", this.enableDrawPolyline);
    window.EventBus.listen("addBulletMarkers", this.addBulletMarkers);
    window.EventBus.listen("addWaypointMarkers", this.addWaypointMarkers);
    window.EventBus.listen("addStopMarkers", this.addStopMarkers);
    window.EventBus.listen("showOnMap", this.showOnMap);
    window.EventBus.listen("deleteFeature", this.deleteFeature);
    window.EventBus.listen("clearAspect", o => {
      this.clearAspect(o.id, o.type);
    });
  },
  mounted() {
    this.getRouteAspectData();
    this.getUserLocationData();
    console.log("map mounted2", this.properties);
    console.warn("map mounted", this.properties);
    this.signals.forEach((element, key) => {
      element.forEach(sig => {
        this.signalsList.push({
          status: key + " " + sig,
          name: key + " " + sig,
          value: key + " " + sig
        });
      });
    });
    this.defaultImg = "https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png";

    if (this.properties.location !== undefined &&
        this.properties.location.hasOwnProperty("latitude")) {
      console.log("beccato", this.properties);
      this.center = ol.proj.fromLonLat([
        Number(this.properties.location.longitude),
        Number(this.properties.location.latitude)
      ]);
    } else {
      this.center = ol.proj.fromLonLat([this.center[0], this.center[1]]);
    }

    //Below code commented out for OSM Map
    let privateLayer = new ol.layer.Tile({
      source: new ol.source.OSM({
        attributions: [
          'All maps © <a href="' + appConfig.tileServer.base + '">Private</a>',
          ol.source.OSM.ATTRIBUTION
        ],
        url: appConfig.tileServer.url,
        crossOrigin: null
      })
    });
    console.log("Lorenzo this.properties", this.properties);
    let initZoom = 6;
    console.log("this.properties", this.properties);
    if (this.properties.profile.hasOwnProperty("zoomLevel")) {
      initZoom = this.properties.profile.zoomLevel;
    }

    this.isDefault = true;
    if (this.properties.interaction !== false) {
      this.interactionMap = true;
    } else if (this.properties.interaction == false) {
      this.interactionMap = false;
    }

    if (this.properties.zoomControls !== false) {
      this.zoomControls = true;
    } else if (this.properties.zoomControls == false) {
      this.zoomControls = false;
    }

    if (this.properties.mouseScrollControls !== false) {
      this.mouseScrollControls = true;
    } else if (this.properties.mouseScrollControls == false) {
      this.mouseScrollControls = false;
    }

    //Below code commented out for Map from OSM
    let container = document.getElementById('popup');

    console.log("Lorenzo container", container);
    this.overlay = new ol.Overlay({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });
    console.log("Lorenzo this.interactionMap", this.interactionMap);
    this.map = new ol.Map({
      layers: [privateLayer],
      overlays: [this.overlay],
      target: this.properties.componentId,
      view: new ol.View({
        center: this.center,
        zoom: initZoom,
        minZoom: appConfig.map.minZoom,
        maxZoom: appConfig.map.maxZoom,
      }),
      //disable and enable map interaction
      interactions: ol.interaction.defaults({
        doubleClickZoom: this.interactionMap,
        dragAndDrop: this.interactionMap,
        dragPan: this.interactionMap,
        keyboardPan: this.interactionMap,
        keyboardZoom: this.interactionMap,
        mouseWheelZoom: this.mouseScrollControls,
        pointer: this.interactionMap,
        select: this.interactionMap,
      }),
      controls: ol.control.defaults({
        attribution: this.zoomControls,
        zoom: this.zoomControls
      })
      // controls: ol.control.defaults().extend([new ol.control.OverviewMap()])
    });
    if (this.zoomControls) {
      let zoomslider = new ol.control.ZoomSlider();
      this.map.addControl(zoomslider);
    }
    this.moveMapToPoint();

    this.initInteractionLayer();
    this.polygonInteraction = new ol.interaction.Draw({
      source: this.drawSource,
      type: "Polygon",
      // minPoints: 3,
      condition: function(mapBrowserEvent) {
        return (
          ol.events.condition.mouseOnly(mapBrowserEvent) &&
          ol.events.condition.altKeyOnly(mapBrowserEvent)
        );
      }
    });

    if (
      this.properties.profile.hasOwnProperty("sea") &&
      this.properties.profile.sea === true
    ) {
      this.createMapLayer();
    }
    this.resizeComponent();
    if (!_.isEmpty(this.properties.params)) {
      let location = null;
      if (!_.isEmpty(this.properties.params.location)) {
        location = this.properties.params.location;
      } else if (!_.isEmpty(this.properties.params.partOf)) {
        location = this.properties.params.partOf;
      }
      if (location !== null) {
        let data = {
          relationId: location.locationId,
          parentId: "",
          state: 3,
          id: location.locationId,
          referenceName: location.name,
          position: [Number(location.longitude), Number(location.latitude)],
          showToolTip: true,
          coordinates: this.revertPolyline(location.polyline)
        };
        if (this.properties.includeCenterPoint == false) {
          data.includeCenterPoint = false;
        } else {
          data.includeCenterPoint = true;
        }
        let locationAspect =
          data.coordinates.split(",").length == 2
            ? new BaseRadiusPointAspect(data)
            : new RelationAspect(data);
        this.putOnMapNew(locationAspect, location.locationId);
        this.moveToFeature2(locationAspect);
      }
    }
  },
  beforeDestroy() {
    window.EventBus.removeListener(
      "rightClickSelectBehaviour",
      this.rightClickSelectBehaviour
    );
    window.EventBus.removeListener("moveToFeature", this.moveToFeature);
    window.EventBus.removeListener("moveToFeature2", this.moveToFeature2);

    window.EventBus.removeListener("generatePolyline", this.generatePolyline);
    window.EventBus.removeListener(
      "generateMultiPolylines",
      this.generateMultiPolylines
    );

    window.EventBus.removeListener(
      "storeSettings" + this.properties.componentId,
      e => this.saveSettings
    );
    window.EventBus.removeListener("TO_STATE_UPDATE", this.toStateUpdate);
    window.EventBus.removeListener("addFeature", this.addFeature);
    window.EventBus.removeListener("aspectUpdate", this.aspectUpdate);
    window.EventBus.removeListener("resize", this.resizeComponent);
    window.EventBus.removeListener("categoriesMarkers", this.categoriesMarkers);
    window.EventBus.removeListener(
      "transportVehicleUpdate",
      this.transportVehicleUpdate
    );
    window.EventBus.removeListener("showTours", this.showTours);
    window.EventBus.removeListener("showRelays", this.showRelays);
    window.EventBus.removeListener("addMarkers", this.addMarkers);
    window.EventBus.removeListener(
      "enableWaypointInteraction",
      this.enableWaypointInteraction
    );
    window.EventBus.removeListener(
      "enableDrawPolyline",
      this.enableDrawPolyline
    );
    window.EventBus.removeListener("focusOnMarker", this.focusOnMarker);
    window.EventBus.removeListener(
      "createAspectBasedOnTypeNew",
      this.createAspectBasedOnTypeNew
    );
    window.EventBus.removeListener("addBulletMarkers", this.addBulletMarkers);
    window.EventBus.removeListener(
      "addWaypointMarkers",
      this.addWaypointMarkers
    );
    window.EventBus.removeListener("addStopMarkers", this.addStopMarkers);
    window.EventBus.removeListener("pictureMarkers", this.pictureMarkers);
    window.EventBus.removeListener("showOnMap", this.showOnMap);
    window.EventBus.removeListener("deleteFeature", this.deleteFeature);
  },
  methods: {
    getRouteAspectData() {
      // websocket connection to get relay aspects
      let sigObjMap = new Map();
      sigObjMap.set(appConfig.dss.eventAdminMng, []);
      sigObjMap
        .get(appConfig.dss.eventAdminMng)
        .push(["routeAspectUpdate", ["RouteAspectData"]]);
      window.EventBus.fire("linkingToRecieveRoutes", sigObjMap);
    },
    getUserLocationData() {
      // websocket connection to get relay aspects
      console.log(
        "Called getUserLocationData from operationalscreen_mapquadrant"
      );
      let sigObjMap = new Map();
      sigObjMap.set(this.currentAccountId, []);
      sigObjMap
        .get(this.currentAccountId)
        .push(["userLocationUpdate", ["userLocationData"]]);
      window.EventBus.fire("linkingToRecieveRoutes", sigObjMap);
    },
    showOnMap(lonLat) {
      // the animation for going to a point on the map
      let coordinate = ol.proj.fromLonLat(lonLat);
      let duration = 1000;
      let zoom = this.map.getView().getZoom();
      this.map.getView().animate({
        center: coordinate,
        duration: duration
      });
      this.map.getView().animate(
        {
          zoom: zoom - 1,
          duration: duration / 2
        },
        {
          zoom: 18,
          duration: duration / 2
        }
      );
    },
    pictureMarkers(markers) {
      // the generation of markers in the triplist
      this.map
        .getLayers()
        .getArray()
        .filter(layer => layer.get("name") === "PictureMarker")
        .forEach(layer => this.map.removeLayer(layer));
      var features = [];
      for (var i = 0; i < markers.length; i++) {
        var item = markers[i];
        var longitude = item.Longitude;
        var latitude = item.Latitude;

        var iconFeature = new ol.Feature({
          geometry: new ol.geom.Point(
            ol.proj.transform([longitude, latitude], "EPSG:4326", "EPSG:3857")
          ),
          elementId: ["activity", i],
          type: markers[i].Type
        });

        var iconStyle = new ol.style.Style({
          image: new ol.style.Icon({
            anchor: [0.5, 1],
            src: '../../assets/traffic-light-red.png',
            scale: 0.1
          })
        });

        iconFeature.setStyle(iconStyle);
        features.push(iconFeature);
      }
      var vectorSource = new ol.source.Vector({
        features: features
      });

      var vectorLayer = new ol.layer.Vector({
        source: vectorSource,
        name: "PictureMarker"
      });
      vectorLayer.setZIndex(100);
      this.map.addLayer(vectorLayer);

      let select = new ol.interaction.Select({});
      this.map.addInteraction(select);

      select.on("select", function(evt) {
        if (evt.target.getFeatures().a.length > 0) {
          let id = evt.target.getFeatures().a[0].N.elementId;
          window.EventBus.fire("selectActivity", id);
          evt.target.getFeatures().clear();
        }
      });
      let self = this;
      // to get the mouse to switch to a pointer when hovering over a feature
      this.map.on("pointermove", function(e) {
        let pixel = self.map.getEventPixel(e.originalEvent);
        let hit = self.map.hasFeatureAtPixel(pixel);
        self.map.getViewport().style.cursor = hit ? "pointer" : "";
      });
    },
    deleteFeature(layerName) {
      // delete feature based on layerName and type
      let filteredLayer = {};
      this.map
        .getLayers()
        .getArray()
        .filter(layer => layer.get("name") === layerName)
        .forEach(layer => (filteredLayer = layer));
      let features = filteredLayer.getSource().getFeatures();
      for (var i = 0; i < features.length; i++) {
        if (features[i].N.type === "Tour") {
          // features[i].style = { visibility: 'hidden' }
          filteredLayer.getSource().removeFeature(features[i]);
        }
      }
    },
    addMarkers(markersArray) {
      // generation for the markers in the themelist and event creation
      this.map
        .getLayers()
        .getArray()
        .filter(layer => layer.get("name") === "marker")
        .forEach(layer => this.map.removeLayer(layer));
      let Markers = [];
      let alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
      if (_.isEmpty(markersArray)) {
        let locationLngLat = this.properties.params.location.polyline.split(
          " "
        );
        let startLocationLng = Number(locationLngLat[0].split(",")[0]);
        let startLocationLat = Number(locationLngLat[0].split(",")[1]);

        let endLocationLngLat = locationLngLat.reverse()[0].split(",");
        let endLocationLng = Number(endLocationLngLat[0]);
        let endLocationLat = Number(endLocationLngLat[1]);
        Markers = [
          {
            lat: startLocationLat,
            lng: startLocationLng,
            color: this.$vuetify.theme.primary
          },
          {
            lat: endLocationLat,
            lng: endLocationLng,
            color: this.$vuetify.theme.primary
          }
        ];
      } else {
        Markers = markersArray;
      }

      var features = [];
      for (var i = 0; i < Markers.length; i++) {
        var item = Markers[i];
        var longitude = item.lng;
        var latitude = item.lat;
        let color = item.color;

        if (item.color != null) {
          var iconFeature = new ol.Feature({
            geometry: new ol.geom.Point(
              ol.proj.transform([longitude, latitude], "EPSG:4326", "EPSG:3857")
            )
          });

          var iconStyle = new ol.style.Style({
            image: new ol.style.Icon({
              anchor: [0.5, 1],
              src: '../../assets/Destination-states/A-BMapMarker.png',
              color: color,
            }),
            text: new ol.style.Text({
              text: alphabet[i],
              offsetY: -18,
              fill: new ol.style.Fill({
                color: "#ffffff",
              })
            })
          });
        } else {
          var iconFeature = new ol.Feature({
            geometry: new ol.geom.Point(
              ol.proj.transform([longitude, latitude], "EPSG:4326", "EPSG:3857")
            ),
            elementId: ["tourActivity", i]
          });

          var iconStyle = new ol.style.Style({
            image: new ol.style.Icon({
              anchor: [0.5, 1],
              src: '../../assets/traffic-light-red.png',
              scale: 0.07
            })
          });
        }

        iconFeature.setStyle(iconStyle);
        features.push(iconFeature);
      }
      var vectorSource = new ol.source.Vector({
        features: features
      });

      var vectorLayer = new ol.layer.Vector({
        source: vectorSource,
        name: "marker"
      });
      vectorLayer.setZIndex(100);
      this.map.addLayer(vectorLayer);
    },
    addWaypointMarkers(waypoints) {
      // generation for the pin markers of waypoints in event creation
      this.map
        .getLayers()
        .getArray()
        .filter(layer => layer.get("name") === "waypoints")
        .forEach(layer => this.map.removeLayer(layer));
      for (let i = 0; i < waypoints.length; i++) {
        if (!Array.isArray(waypoints[i].Name)) {
          waypoints[i].Name = waypoints[i].Name.split(",");
        }
      }
      let marker = this.$store.getters.getMapMarkerPin;
      let features = [];
      for (let i = 0; i < waypoints.length; i++) {
        let waypointText = (i + 1).toString();
        let item = waypoints[i];
        let longitude = Number(item.Name[0]);
        let latitude = Number(item.Name[1]);
        let iconFeature = new ol.Feature({
          geometry: new ol.geom.Point(
            ol.proj.transform([longitude, latitude], "EPSG:4326", "EPSG:3857")
          ),
          WaypointId: waypoints[i].Id
        });
        var iconStyle = new ol.style.Style({
          image: new ol.style.Icon({
            anchor: [0.5, 1],
            src: '../../assets/Destination-states/mapMarkerLarge.png',
            color: this.$vuetify.theme.secondary,
          }),
          text: new ol.style.Text({
            text: waypointText,
            offsetY: -21,
            fill: new ol.style.Fill({
              color: "#ffffff"
            })
          })
        });
        iconFeature.setStyle(iconStyle);
        features.push(iconFeature);
      }
      let vectorSource = new ol.source.Vector({
        features: features
      });
      let vectorLayer = new ol.layer.Vector({
        source: vectorSource,
        name: "waypoints"
      });
      vectorLayer.setZIndex(99);
      this.map.addLayer(vectorLayer);
      this.vectorLayerWaypoints = vectorLayer;
      for (let i = 0; i < waypoints.length; i++) {
        if (Array.isArray(waypoints[i].Name)) {
          waypoints[i].Name = waypoints[i].Name.join(",");
        }
      }
    },
    addStopMarkers(stops) {
      // generation for the public transport stop markers in event creation
      this.map
        .getLayers()
        .getArray()
        .filter(layer => layer.get("name") === "stops")
        .forEach(layer => this.map.removeLayer(layer));
      for (let i = 0; i < stops.length; i++) {
        if (!Array.isArray(stops[i].Name)) {
          stops[i].Name = stops[i].Name.split(",");
        }
      }
      let marker = this.$store.getters.getMapMarkerPin;
      let features = [];
      for (let i = 0; i < stops.length; i++) {
        let stopText = (i + 1).toString();
        let item = stops[i];
        let longitude = Number(item.Name[0]);
        let latitude = Number(item.Name[1]);
        console.log("longitude: ", longitude);
        console.log("latitude: ", latitude);
        let iconFeature = new ol.Feature({
          geometry: new ol.geom.Point(
            ol.proj.transform([longitude, latitude], "EPSG:4326", "EPSG:3857")
          ),
          StopId: stops[i].Id
        });
        var iconStyle = new ol.style.Style({
          image: new ol.style.Icon({
            anchor: [0.5, 0.5],
            color: 'red',
            src: '../../assets/Destination-states/mapMarkerLarge.png',
            scale: 0.5,
          }),
          text: new ol.style.Text({
            text: stopText,
            offsetY: -21,
            fill: new ol.style.Fill({
              color: "#ffffff"
            })
          })
        });
        iconFeature.setStyle(iconStyle);
        features.push(iconFeature);
      }
      let vectorSource = new ol.source.Vector({
        features: features
      });
      let vectorLayer = new ol.layer.Vector({
        source: vectorSource,
        name: "stops"
      });
      vectorLayer.setZIndex(99);
      this.map.addLayer(vectorLayer);
      this.vectorLayerStops = vectorLayer;
      for (let i = 0; i < stops.length; i++) {
        if (Array.isArray(stops[i].Name)) {
          stops[i].Name = stops[i].Name.join(",");
        }
      }
    },
    addBulletMarkers(bulletMarkers) {
      // generation of the bulletpoint markers in event creation
      if (!this.properties.interaction) {
        return;
      }
      this.map
        .getLayers()
        .getArray()
        .filter(layer => layer.get("name") === "bulletMarkers")
        .forEach(layer => this.map.removeLayer(layer));

      for (let i = 0; i < bulletMarkers.length; i++) {
        if (!Array.isArray(bulletMarkers[i].Name)) {
          bulletMarkers[i].Name = bulletMarkers[i].Name.split(",");
        }
      }
      let features = [];
      for (let i = 0; i < bulletMarkers.length; i++) {
        let item = bulletMarkers[i];
        let longitude = Number(item.Name[0]);
        let latitude = Number(item.Name[1]);

        let bulletMarkerFeature = new ol.Feature({
          geometry: new ol.geom.Point(
            ol.proj.transform([longitude, latitude], "EPSG:4326", "EPSG:3857")
          ),
          idFromBulletmarker: bulletMarkers[i].Id
        });

        let bulletMarkerStyle = new ol.style.Style({
          cursor: "pointer",
          image: new ol.style.Circle({
            radius: 4,
            fill: new ol.style.Fill({
              color: "#0c0c0c"
            })
          })
        });

        bulletMarkerFeature.setStyle(bulletMarkerStyle);
        features.push(bulletMarkerFeature);
      }
      let vectorSource = new ol.source.Vector({
        features: features
      });

      let vectorLayer = new ol.layer.Vector({
        source: vectorSource,
        name: "bulletMarkers"
      });

      let select = new ol.interaction.Select({
        layers: [vectorLayer]
      });
      this.map.addInteraction(select);

      // on click function
      select.on("select", function(evt) {
        if (evt.target.getFeatures().a.length > 0) {
          let id = evt.target.getFeatures().a[0].N.idFromBulletmarker;
          window.EventBus.fire("selectWaypoint", id);
        }
      });

      vectorLayer.setZIndex(98);

      this.map.addLayer(vectorLayer);
      for (let i = 0; i < bulletMarkers.length; i++) {
        if (Array.isArray(bulletMarkers[i].Name)) {
          bulletMarkers[i].Name = bulletMarkers[i].Name.join(",");
        }
      }
    },
    enableWaypointInteraction() {
      // enable click on the map to set a waypoint in the event creation
      const self = this;
      this.disableWaypointInteraction = false;
      this.map.on("click", function(evt) {
        // Get the pointer coordinate
        let mousePositionCoordinate = ol.proj.transform(
          evt.coordinate,
          "EPSG:3857",
          "EPSG:4326"
        );
        mousePositionCoordinate[0] = mousePositionCoordinate[0].toFixed(6);
        mousePositionCoordinate[1] = mousePositionCoordinate[1].toFixed(6);
        mousePositionCoordinate = mousePositionCoordinate.join();
        self.addWaypoint(mousePositionCoordinate);
        self.map.removeEventListener("click");
      });
    },
    addWaypoint(mousePositionCoordinate) {
      if (this.disableWaypointInteraction == false) {
        this.$emit("setWaypoints", mousePositionCoordinate);
      } else {
        return;
      }
    },
    generateTourPoints(data) {
      // generation for the public transport stop markers in event creation
      this.map
        .getLayers()
        .getArray()
        .filter(layer => layer.get("name") === "pathPointsAndPolyline")
        .forEach(layer => this.map.removeLayer(layer));

      let features = [];

      data.routeAspects.forEach( aspect => {
        let polylineArray = [];
        if (aspect.DataFieldTable.hasOwnProperty('PathPoints')) {
            aspect.DataFieldTable.PathPoints.forEach((item, index) => {
            polylineArray.push([
              item.Longitude,
              item.Latitude
            ]);
            let iconFeature = new ol.Feature({
              geometry: new ol.geom.Point(
                ol.proj.transform([item.Longitude, item.Latitude], "EPSG:4326", "EPSG:3857")
              ),
              StopId: index
            });

            let iconStyle = {};

          // if (index === 0 || index === (aspect.DataFieldTable.PathPoints.length - 1)) {
          //   iconStyle = new ol.style.Style({
          //     image: new ol.style.Icon({
          //       anchor: [0.5, 0.5],
          //       color: "#5d94c2",
          //       src: '../../assets/Destination-states/mapMarkerLarge.png',
          //       scale: 1,
          //     }),
          //     text: new ol.style.Text({
          //       text: index === 0 ? 'A' : 'B',
          //       offsetY: 0,
          //       scale: 1.5,
          //       fill: new ol.style.Fill({
          //         color: "#ffffff"
          //       })
          //     })
          //   });
          //   }
          if (item.StopNr === -1) {
              iconStyle = new ol.style.Style({
                image: new ol.style.Icon({
                  anchor: [0.5, 0.5],
                  color: 'black',
                  src: '../../assets/Destination-states/mapMarkerLarge.png',
                  scale: 0.5,
                }),
              });
            } else {
              iconStyle = new ol.style.Style({
                image: new ol.style.Icon({
                  anchor: [0.5, 0.5],
                  color: '#3CAEA3',
                  src: '../../assets/Destination-states/mapMarkerLarge.png',
                  scale: 1,
                }),
                text: new ol.style.Text({
                  text: item.StopNr.toString(),
                  offsetY: 0,
                  scale: 1.5,
                  fill: new ol.style.Fill({
                    color: "#ffffff"
                  })
                })
              });
            }
            if (!this.properties.interaction) {
              if (item.StopNr !== -1) {
              // if (item.StopNr !== -1 || index === 0 || index === (aspect.DataFieldTable.PathPoints.length - 1)) {
                iconFeature.setStyle(iconStyle);
                features.push(iconFeature);
              }
            } else {
              iconFeature.setStyle(iconStyle);
              features.push(iconFeature);
            }
          });
        }

        let polyline = new ol.geom.LineString(polylineArray);
        polyline.transform("EPSG:4326", "EPSG:3857");

        let polylineFeature = new ol.Feature({
          geometry: polyline,
          coordinates: false,
        });

        let polylineStyle = new ol.style.Style({
          stroke: new ol.style.Stroke({
            color: "#0000FF",
            width: 3
          })
        });
        if (data.disableChangeView === false) {
          if (!this.properties.interaction) {
            this.map.getView().fit(polyline);
          } else {
            this.map.getView().fit(polyline);
          }
        }
        polylineFeature.setStyle(polylineStyle);

        features.push(polylineFeature);
        // features.push(iconFeature);
      });
      let vectorSource = new ol.source.Vector({
        features: features
      });

      let vectorLayer = new ol.layer.Vector({
        source: vectorSource,
        name: "pathPointsAndPolyline"
      });

      vectorLayer.setZIndex(99);
      this.map.addLayer(vectorLayer);
    },
    selectTourFeature() {
      let select = new ol.interaction.Select({});
      this.map.addInteraction(select);


      // on click function
      select.on("select", function(evt) {

        if (evt.target.getFeatures().a.length > 0) {
          let id = evt.target.getFeatures().a[0].N.StopId;
          window.EventBus.fire("selectWaypoint", id);
        }
      });
    },
    generatePolyline(dontChangeMapView) {
      // generation of the polyline
      if (!_.isEmpty(this.properties.params)) {
        let location = null;
        if (!_.isEmpty(this.properties.params.location)) {
          location = this.properties.params.location;
        } else if (!_.isEmpty(this.properties.params.partOf)) {
          location = this.properties.params.partOf;
        }
        if (location !== null) {
          let data = {
            relationId: location.locationId,
            parentId: "",
            state: 3,
            id: location.locationId,
            referenceName: location.name,
            position: [Number(location.longitude), Number(location.latitude)],
            showToolTip: true,
            coordinates: this.revertPolyline(location.polyline)
          };
          if (this.properties.includeCenterPoint == false) {
            data.includeCenterPoint = false;
          } else {
            data.includeCenterPoint = true;
          }
          if (this.properties.tooltip == false) {
            data.showToolTip = false;
          }

          let locationAspect =
            data.coordinates.split(",").length == 2
              ? new BaseRadiusPointAspect(data)
              : new RelationAspect(data);
          this.putOnMapNew(locationAspect, location.locationId);

          if (!dontChangeMapView) {
            this.moveToFeature2(locationAspect);
          }
        }
      }
    },
    generateMultiPolylines(polylineArray) {
      let count = 0;
      for (let polyline of polylineArray) {
        let data = {
          relationId: "xxx" + count,
          parentId: "",
          state: 3,
          id: "xxx" + count,
          referenceName: "xxx" + count,
          position: [4.792517, 53.009781],
          showToolTip: true,
          coordinates: this.revertPolyline(polyline)
        };

        let locationAspect =
          polyline.split(",").length == 2
            ? new BaseRadiusPointAspect(data)
            : new RelationAspect(data);
        this.putOnMapNew(locationAspect, "xxx" + count);

        count += 1;
      }
    },
    /**
     * function to revert polyline "string" from <lat,lon> to <lon,lat>
     * and viceversa
     */
    revertPolyline(polyline) {
      let tmp = polyline.split(" ");
      let newPolyline = "";
      tmp.forEach(i => {
        let h = i.split(",");
        newPolyline += h.reverse().join() + " ";
      });
      return newPolyline;
    },
    goToMainScreen() {
      window.EventBus.fire("setMainContentComponent", {
        component: "Locations_Main",
        params: {}
      });
      window.EventBus.fire("setSideComponentName", {
        component: "NavigationOverview",
        params: {
          reload: true
        }
      });
    },
    resizeComponent() {
      setTimeout(() => {
        this.map.updateSize();
      }, 200);
    },
    dismissSettings() {},
    saveSettings(e) {
      this.signalsList.forEach(element => {
        if (element.status == null) {
        }
      });
    },
    insertIncident(gps) {
      //Removed this call as we do not need floating box to add incidents
      window.EventBus.fire("fillIncidentLocation", gps);
    },
    beforeCleanWebSocket() {},
    onEvent({
              data: data
              // signal: signal = null,
              // intersectionAspectList: intersectionAspectList = null,
              // toBeDeletedAspectList: toBeDeletedAspectList = null,
              // toBeAddedAspectList: toBeAddedAspectList = null
            }) {
      // clean map layer
      console.log("ASPECT", data);
      const aspectType = this.getAspectName(data.Name);
      this.clearSource(aspectType);

      this.getAspectsListNew(data, this);
    },
    // onEvent(container) {
    //   console.log("ASPECT", container)
    // },
    getAspectName(aspectName) {
      let aspectType = null;
      switch (aspectName) {
        case "LocationAspectUpdate":
          aspectType = "Location";
          break;
        case "incidentAspectUpdate":
          aspectType = "Incident";
          break;
        case "userAspectUpdate":
          aspectType = "User";
          break;
        default:
          console.warn("onEvent TYPE not recognized", aspectName);
          break;
      }
      return aspectType;
    },
    getAspectsListNew(response, callback, focusedAspectTypes = null) {
      console.log("response etc etc", response, callback, focusedAspectTypes);
      if (response.Name === undefined || response.Name == "") {
        console.warn("getAspectsListNew No Name specified", response);
        return;
      }
      delete response.Name;
      delete response.ObjectId;
      for (const v of Object.values(response.Data)) {
        if (v.hasOwnProperty("Id")) {
          this.createAspectBasedOnTypeNew(v, callback);
        }
      }
    },
    createAspectBasedOnTypeNew(aspect, callback = null) {
      callback = this;

      let addToMap = true,
        toBeRemoved = false;
      let _obj = BaseObject._toLowerCaseObjectProperties(aspect);
      _obj.position = [Number(_obj.longitude), Number(_obj.latitude)];
      console.log("_obj nu", _obj);
      let genericAspect = {};
      switch (_obj.type) {
        case "Location":
          let tmp = _obj.dataFieldTable.polyline.split(" ");
          let newPolyline = "";
          tmp.forEach(i => {
            let h = i.split(",");
            newPolyline += h.reverse().join() + " ";
          });

          _obj.coordinates = newPolyline;
          delete _obj.dataFieldTable.polyline;
          genericAspect = new LocationAspect(_obj);
          this.focusOnPolyline(_obj.coordinates);
          break;

        case "Incident":
          genericAspect = new IncidentAspect(_obj);
          break;

        case "User":
          genericAspect = new UserAspect(_obj);
          break;

        default:
          console.warn("createAspectBasedOnTypeNew NO type recognized", _obj);
          return;
      }
      if (callback !== null)
        callback.addObject({ genericAspect, aspect, addToMap, toBeRemoved });

      return { genericAspect, aspect, addToMap, toBeRemoved };
    },
    populateObjList(objList, relList = null) {
      this.allObjectList = objList;
      if (relList) {
        this.$store.commit("setRelationList", relList);
      }
      this.$store.commit("setAllObjectFromTree", this.allObjectList);
      this.allObjectList = [];
    },
    enableDrawPolyline() {
      // enable to draw a freehand polyline on the map in event creation
      if (!this.properties.interaction) {
        return;
      }
      const vectorSource = new ol.source.Vector({
        wrapX: false
      });
      let draw = new ol.interaction.Draw({
        source: vectorSource,
        type: "LineString"
      });
      this.map.addInteraction(draw);
      let self = this;
      draw.on("drawend", function(evt) {
        let coordinates = evt.feature.getGeometry().getCoordinates();
        let transformedCoordinated = [];
        for (let i = 0; i < coordinates.length; i++) {
          let tmp = ol.proj.transform(coordinates[i], "EPSG:3857", "EPSG:4326");
          tmp[0] = Number(tmp[0]).toFixed(6);
          tmp[1] = Number(tmp[1]).toFixed(6);
          transformedCoordinated.push(tmp);
        }
        window.EventBus.fire("disableDrawPolyline", transformedCoordinated);
        self.map.removeInteraction(draw);
      });
    },
    focusOnPolyline(coordinates) {
      // zoom and move to the polyline
      let nnn = BaseAspect._trasformPolylinecoordinates(coordinates);
      let size = this.map.getSize();
      if (this.properties.sizeOffset !== undefined) {
        size[0] = size[0] - this.properties.sizeOffset;
        size[1] = size[1] - this.properties.sizeOffset;
      }
      let extent = ol.extent.boundingExtent(nnn);
      this.map.getView().fit(extent, {
        size: size,
        maxZoom: appConfig.map.maxZoom,
        duration: 0
      });
    },
    focusOnMarker(coordinate) {
      // go to a point on the map without any animation
      this.map
        .getView()
        .setCenter(ol.proj.transform(coordinate, "EPSG:4326", "EPSG:3857"));
    },
    initInteractionLayer() {
      this.drawSource = new ol.source.Vector({
        wrapX: false
      });
      this.drawInteractionLayer = new ol.layer.Vector({
        source: this.drawSource
      });
    },
    drawListenter(event) {
      if (event.type == "drawend") {
        const geometry = event.feature.getGeometry();
        this.removePolygonInteraction();
        this.polygonInteraction.un("drawend", this.drawListenter);
        const arrayCoordinates = geometry.getCoordinates();
        let transformedCoordinated = Array(arrayCoordinates[0].length);
        for (let i = 0; i < arrayCoordinates[0].length; i++) {
          const tmp = ol.proj.transform(
            arrayCoordinates[0][i],
            "EPSG:3857",
            "EPSG:4326"
          );
          transformedCoordinated[i] = tmp;
        }
        const gps = {
          coordinates: transformedCoordinated,
          end: true
        };
        window.EventBus.fire("clickedLocationDestination", gps);
      }
    },
    addPolygonInteraction() {
      if (this.mapLayers["drawInteractionLayer"] == undefined) {
        this.mapLayers["drawInteractionLayer"] = this.drawInteractionLayer;
        this.map.addLayer(this.drawInteractionLayer);
      } else {
        this.drawSource.clear();
      }

      this.polygonInteraction.on("drawend", this.drawListenter);
      this.map.addInteraction(this.polygonInteraction);
    },
    removePolygonInteraction() {
      this.map.removeInteraction(this.polygonInteraction);
    },
    removePolygonLayer() {
      if (this.mapLayers["drawInteractionLayer"] != undefined) {
        this.map.removeLayer(this.drawInteractionLayer);
        this.mapLayers["drawInteractionLayer"] = undefined;
      }
    },
    // Main callback function to set the right click behaviour in the store
    rightClickSelectBehaviour(value) {
      this.$store.commit("setRightClickBehaviour", value);

      this.clearSource("NEW_DESTINATION_POINT");
      switch (value) {
        case 0:
          this.clearSource("NEW_DESTINATION_POINT");
          this.removePolygonLayer();
          this.removePolygonInteraction();
          break;
        case 1:
          break;
        case 3:
          this.drawSource.clear();
          this.addPolygonInteraction();
          break;
        case 5:
          break;
        case 6:
          this.removePolygonInteraction();
          break;
      }
    },
    addFeature(feature) {
      const type = feature.get("type");
      let id = feature.getId();

      if (id === undefined) {
        id = feature.get("id");
      }
      if (!this.checkLayerExists(feature)) {
        this.createLayer(feature);
      } else {
        this.clearAspect(id, type);
      }

      this.layerSources[type].addFeature(feature);
      this.copyProperties(this.objectHashMap[id], feature);
      this.objectHashMap[id] = feature;
    },
    // if it was set "object remove, it will be preserved"
    copyProperties(featureSrc, featureDst) {
      if (typeof featureSrc !== "undefined") {
        featureDst.setLastAction(featureSrc.getLastAction());
      }
    },
    checkLayerExists(feature) {
      var layers = Object.keys(this.layerSources);
      var check = layers.indexOf(feature.get("type"));
      if (check === -1) {
        return false;
      }
      return true;
    },
    createMapLayer(feature) {
      var openSeaMapLayer = new ol.layer.Tile({
        source: new ol.source.OSM({
          attributions: [
            'All maps © <a href="http://www.openseamap.org/">OpenSeaMap</a>',
            ol.source.OSM.ATTRIBUTION
          ],
          opaque: false,
          url: "https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png",
          crossOrigin: null
        })
      });
      this.map.addLayer(openSeaMapLayer);
    },
    createLayer(feature) {
      const vectorSource = new ol.source.Vector({});
      this.layerSources[feature.get("type")] = vectorSource;
      const vectorLayer = new ol.layer.Vector({
        name: feature.get("type"),
        source: vectorSource,
        renderBuffer: 100000
      });
      vectorLayer.setZIndex(feature.getZIndex());
      this.mapLayers[feature.get("type")] = vectorLayer;
      this.map.addLayer(vectorLayer);
    },
    createLayerWithType(type) {
      const vectorSource = new ol.source.Vector({});
      this.layerSources[type] = vectorSource;
      const vectorLayer = new ol.layer.Vector({
        name: type,
        source: vectorSource,
        renderBuffer: 100000
      });
      vectorLayer.setZIndex(15);
      this.mapLayers[type] = vectorLayer;
      this.map.addLayer(vectorLayer);
    },
    toStateUpdate(data) {
      if (data.hasOwnProperty("TO_STATE") && data.hasOwnProperty("ObjectId")) {
        let objId = data.ObjectId.value;
        let OBJID = data.OBJECTID.value;
        switch (data.TO_STATE.value) {
          case 1:
            // Removing if it was previously inserted and linked

            if (typeof this.objectHashMap[objId] !== "undefined") {
              let _feature = this.objectHashMap[objId];
              if (_feature.getLastAction() === "removeObject") {
                let ref = this.layerSources[_feature.get("type")];
                if (typeof ref !== "undefined") {
                  if (ref.getFeatureById(objId) !== null) {
                    if (_feature.get("type") === "AreaManager") {
                      this.$store.commit("removeAreaManager", objId);
                    }
                    //call the removeAreaManager
                    ref.removeFeature(ref.getFeatureById(objId));
                    delete this.objectHashMap[objId];
                  }
                }
              } else {
                console.warn("TO_STATE 1 but no removing...", objId);
              }
            }
            break;
          case 3:
            if (data.hasOwnProperty("TYPE")) {
              switch (data.TYPE.value) {
                case "AreaManager":
                case "RoadRelation":
                  if (
                    data.hasOwnProperty("IncidentQuadrant") &&
                    data.IncidentQuadrant.hasOwnProperty("AspectList")
                    // && objId == 'Texel'
                  ) {
                    this.getAspectsList(data.IncidentQuadrant);
                  } else {
                  }
                  break;

                default:
                  break;
              }
            }
            break;
          case 2:
            if (data.hasOwnProperty("TYPE")) {
              switch (data.TYPE.value) {
                case "AreaBuilder":
                  this.$notify.info({
                    title: "Warning",
                    message: "The Area Builder object is not ready!",
                    duration: 0
                  });
                  break;
              }
            }
            break;
          default:
            break;
        }
      }
    },
    relationStatusUpdate(data) {
      dssUtility.dSSForEach(data.WayData, (wayId, way) => {
        dssUtility.dSSForEach(way, (segmentIndex, segment) => {
          if (typeof this.layerSources.Segment !== "undefined") {
            // delete a feature if it already exists
            this.layerSources.Segment.removeFeature(
              this.layerSources.Segment.getFeatureById(segment.SegmentId.value)
            );
          }

          segment.RelationId = {
            datatype: "int",
            value: data.ObjectId.value
          };
          this.createSegmentBasedOnType(segment);
        });
      });
    },
    createSegmentBasedOnType(segment) {
      // trick until relation aspect will have its own reference Name
      if (!segment.hasOwnProperty("RelationName")) {
        segment.RelationName = segment.RelationId;
      }

      if (segment.Polyline.value !== "") {
        let segmentClass = new RelationAspect({
          id: segment.SegmentId.value,
          type: "Segment",
          state: segment.State.value,
          intensity: segment.Intensity.value,
          reliability: segment.Reliability.value,
          velocity: segment.Velocity.value,
          coordinates: segment.Polyline.value,
          relationId: segment.RelationId.value,
          referenceName: segment.RelationName.value,
          timestamp: segment.Timestamp.value
        });
        if (segmentClass.hasOwnProperty("isFake")) {
          segmentClass.isFake = segmentClass.isFake;
        }
        let segmentFeature = segmentClass.createFeature();
        segmentFeature.setId(segment.SegmentId.value);
        this.addFeature(segmentFeature);
      }
    },
    moveToPreferredArea() {
      if (
        typeof this.defaultArea !== "undefined" &&
        this.defaultArea !== "" &&
        typeof _preferredArea !== "undefined" &&
        _preferredArea !== ""
      ) {
        let centerLat =
          (Number(_preferredArea.area.DataFieldTable.LatTopRight) +
            Number(_preferredArea.area.DataFieldTable.LatBottomLeft)) /
          2;
        let centerLon =
          (Number(_preferredArea.area.DataFieldTable.LonTopRight) +
            Number(_preferredArea.area.DataFieldTable.LonBottomLeft)) /
          2;
        if (!isNaN(centerLat) && !isNaN(centerLon)) {
          this.center = ol.proj.fromLonLat([centerLon, centerLat]);
        }
      } else {
        this.center = ol.proj.fromLonLat(this.center);
      }
      this.moveMapToPoint();
    },
    addObject(data) {
      // player.beep();
      if (data.addToMap && !data.toBeRemoved) {
        let mapFeature = data.genericAspect.createFeature();
        mapFeature.setId(data.aspect.Id);
        this.addFeature(mapFeature);

        this.map.updateSize();
      } else {
      }
    },
    putOnMapNew(genericAspect, Id = 0, cleanLayer = false) {
      if (cleanLayer === true) {
        this.clearSource(genericAspect.get("type"));
      }

      let mapFeature = genericAspect.createFeature();
      mapFeature.setId(Id);
      this.addFeature(mapFeature);
    },
    moveToFeature2(feature) {
      this.objectHashMap[feature.id] = feature;
      this.moveToFeature(feature.getObject());
      this.tooltipElement = feature.createTooltip();

      this.focusOnPolyline(feature.getObject().coordinates);
    },
    moveToFeature(feature) {
      let id = feature.id;

      if (feature.position.length == 2) {
        let _feature = this.objectHashMap[id];
        this.center = ol.proj.fromLonLat([
          _feature.get("position")[0],
          _feature.get("position")[1]
        ]);
        this.moveMapToPoint();
      } else {
        this.focusOnPolyline(feature.coordinates);
      }
    },
    moveMapToPoint(zoom = this.zoom) {
      this.map.getView().animate({
        center: this.center,
        duration: 0,
        zoom: zoom
      });
    },
    changeZIndex(feature, newZIndex) {
      let vectorLayer = this.mapLayers[feature.get("type")];
      vectorLayer.setZIndex(newZIndex);
    },
    /* Main entry point for the mouse over on the map*/
    mouseOver(event) {
      let pixel = this.map.getEventPixel(event);
      if (
        !this.map.forEachFeatureAtPixel(pixel, feature => {
          this.tooltipElement = {};
          if (typeof feature.createTooltip === "function") {
            this.tooltipElement.html = feature.createTooltip();
          }
          if (typeof feature.showMouseOver === "function") {
            this.hideLastFeature();
            feature.showMouseOver();
            this.changeZIndex(feature, 20);
            this.lastSelectedFeature = feature;
          }

          this.tooltipElement.styleObject = {
            left: pixel[0] + 10 + "px",
            top: pixel[1] + 10 + 49 + "px",
            height: "auto",
            position: "absolute",
            background: "#e4e4e3",
            padding: "5px 0px 0px 5px"
          };
          return true;
        })
      ) {
        // remove the tooltip
        // if(this.tooltipElement !== null){
        this.tooltipElement = null;
        this.hideLastFeature();
      }
    },
    hideLastFeature() {
      if (this.lastSelectedFeature != "") {
        this.lastSelectedFeature.hideMouseOver();
        this.changeZIndex(
          this.lastSelectedFeature,
          this.lastSelectedFeature.getOrigZIndex()
        );
        this.lastSelectedFeature = "";
      }
    },
    getGpsCoord(event) {
      let pixel = this.map.getEventPixel(event);
      let location = this.getTranslatedLocation(pixel);
      if (location === null) {
        return;
      }
      const coordinates = this.getCoordinates(pixel);
      const gps = {
        degrees: location,
        decimal: coordinates
      };
      return gps;
    },
    manageLeftClick(event) {
      if (this.disableAction === true) {
        return;
      }
      this.clearSource("NEW_DESTINATION_POINT");

      const pixel = this.map.getEventPixel(event);
      const gps = this.getGpsCoord(event);

      if (
        !this.map.forEachFeatureAtPixel(pixel, feature => {
          if (
            typeof feature.setLinkStatusIfNotLinked === "function" &&
            typeof feature.leftClick === "function"
          ) {
            feature.setLinkStatusIfNotLinked();
            feature.leftClick();
          }
          // in order to avoid common behaviour from map right click
          return true;
        })
      ) {
      }
    },
    /* Main entry point for the right click on the map*/
    manageRightClick(event) {
      if (this.properties.rightClick === false) {
        return;
      }
      const pixel = this.map.getEventPixel(event);
      const gps = this.getGpsCoord(event);

      let rightClickBehaviour = this.$store.getters.getRightClickBehaviour;
      let forwardBehave = true;
      switch (rightClickBehaviour) {
        case 0: // normal behaviour
          this.clearSource("NEW_DESTINATION_POINT");
          break;
        case 1: // add point on the map and forward coordinates
          forwardBehave = false;
          this.createDummyPoint(gps.decimal);
          break;
        case 3:
          forwardBehave = false;
          this.clearSource("NEW_DESTINATION_POINT");
          this.createDummyPoint(gps.decimal, 1);
          break;
        case 5: // early set for parking spot, it needs a gps position
          forwardBehave = false;
          this.clearSource("NEW_DESTINATION_POINT");
          break;
        default:
          // normal behaviour

          break;
      }

      if (forwardBehave) {
        if (
          !this.map.forEachFeatureAtPixel(pixel, function(feature) {
            if (typeof feature.setLinkStatusIfNotLinked === "function") {
              feature.setLinkStatusIfNotLinked();
            }
            feature.rightClick(pixel, gps, rightClickBehaviour);

            //in order to avoid common behaviour from map right click
            return true;
          })
        ) {
          this.createDummyPoint(gps.decimal);
          if (
            !(
              this.properties.profile.hasOwnProperty("landing") &&
              this.properties.profile.landing == true
            )
          ) {
            //Removed this call as we do not need floating box to add the incident
            this.insertIncident(gps);
          } else {
            window.EventBus.fire("clickedLocation", gps);
          }

          // Right click on plain map
        } else {
          window.EventBus.fire("clickedLocation", gps);
        }
      } else {
        window.EventBus.fire("clickedLocation", gps);
      }
    },
    createDummyPoint(coordinates, type = 0) {
      let data = {
        id: "NEW_DESTINATION_POINT",
        type: "NEW_DESTINATION_POINT",
        position: [coordinates[0], coordinates[1]],
        referenceName: "point_XXX",
        parentId: 0
      };
      let newPoint = null;
      if (type === 0) newPoint = new BasePointAspect(data);
      else newPoint = new BaseRadiusPointAspect(data);
      let feature = newPoint.createFeature();
      this.addFeature(feature);
    },
    getTranslatedLocation(pixel) {
      let clickedCordinates = this.getCoordinates(pixel);
      if (clickedCordinates === null) {
        return null;
      }
      let location = this.ddToDms(clickedCordinates[1], clickedCordinates[0]);
      return location;
    },
    getCoordinates(pixel) {
      let clickedCordinates = this.map.getCoordinateFromPixel(pixel);
      if (clickedCordinates === null) {
        return null;
      }
      clickedCordinates = ol.proj.transform(
        clickedCordinates,
        "EPSG:3857",
        "EPSG:4326"
      );
      return clickedCordinates;
    },
    clearSource(layer) {
      if (typeof this.layerSources[layer] !== "undefined") {
        this.layerSources[layer].forEachFeature(feature => {
          this.layerSources[layer].removeFeature(feature);
        });
      } else {
      }
    },
    clearAspect(id, type) {
      let foundAndRemoved = false;
      let ref = this.layerSources[type];
      if (typeof ref !== "undefined") {
        if (ref.getFeatureById(id) !== null) {
          ref.removeFeature(ref.getFeatureById(id));
          foundAndRemoved = true;
          delete this.objectHashMap[id];
        }
      }
      return foundAndRemoved;
    },
    /**
     * function to update all the aspects
     * with udpated data in the Map
     */
    updateAspects(type, toBeUpdatedAspectsList) {
      const ref = this.layerSources[type];
      if (typeof ref === "undefined") {
        // console.error("updateAspects NO LAYER EXIST", type);
        return;
      }
      for (const [k, v] of Object.entries(toBeUpdatedAspectsList)) {
        // debugger;
        if (ref.getFeatureById(k) !== null) {
          const container = this.createAspectBasedOnType2(v);
          ref.getFeatureById(k).setProperties(container.data);
        } else {
          console.warn("NULL ref.getFeatureById(k)", k);
        }
      }
    },
    createAspectBasedOnType2(aspect, callback = null) {
      let genericAspect = {};
      let addToMap = true;
      let toBeRemoved = false;

      let data = {
        id: aspect.Id,
        referenceName: aspect.Name,
        position: []
      };
      if (aspect.DataFieldTable.hasOwnProperty("ParentId")) {
        data.parentId = aspect.DataFieldTable.ParentId;
      }
      if (aspect.hasOwnProperty("state")) {
        data.state = aspect.DataFieldTable.State;
      }
      if (
        aspect.hasOwnProperty("Longitude") &&
        aspect.hasOwnProperty("Latitude")
      ) {
        if (
          aspect.Longitude == 0.0 &&
          aspect.Latitude == 0.0 &&
          aspect.DataFieldTable.Polyline == ""
        ) {
          console.warn("aspect to do not show", aspect);
          // return;
          aspect.Longitude == 0.1;
          aspect.Latitude == 0.1;
          // addToMap = false;
        }
        data.position = [Number(aspect.Longitude), Number(aspect.Latitude)];
      }
      if (aspect.DataFieldTable.TO_STATE == 1) {
        //remove object
        toBeRemoved = true;
      }

      switch (aspect.Type) {
        case "TestAspect":
        case "BusStop":
        case "Bus":
        case "TrafficJam":
        case "Accident":
        case "RoadWork":
        case "EmergencyService":
          genericAspect = new DefaultAspect(data, aspect.Type);
          if (this.currentAspect < this.maxAspect) {
            this.currentAspect++;
          }
          break;

        case "USER":
          data.timestamp = aspect.DataFieldTable.DateTime;
          data.customerGroup = aspect.DataFieldTable.CustomerGroupName;
          data.userName = aspect.DataFieldTable.UserName;
          // data.subType = aspect.DataFieldTable.SubType;
          // data.userCategory = aspect.DataFieldTable.UserCategory;
          data.userCategory = "officials";
          genericAspect = new UserAspect(data);
          break;

        case "EntryPoint":
          data.category = aspect.DataFieldTable.Category;
          data.maxCapacity = aspect.DataFieldTable.MaxCapacity;
          data.arrivalRateLimit = aspect.DataFieldTable.ArrivalRateLimit;
          data.subType = aspect.DataFieldTable.SubType;
          genericAspect = new EntryPointAspect(data);

          break;

        case "INCIDENT":
        case "Incident":
          if (aspect.DataFieldTable.State != "OFF") {
            data.date = new Date(Number(aspect.DataFieldTable.DateTime) * 1000);
            data.description = aspect.DataFieldTable.Description;
            data.state = aspect.DataFieldTable.State;
            data.incidentType = aspect.DataFieldTable.IncidentType;
            data.incidentId = aspect.Id;
            genericAspect = new IncidentAspect(data);
          } else {
            addToMap = false;
            callback.clearAspect(data.id, "Incident");
          }
          genericAspect = new IncidentAspect(data);

          break;

        case "ParkingFacility":
          data.operationalState = aspect.DataFieldTable.OperationalState;
          data.stateText = aspect.DataFieldTable.StateText;
          data.state = aspect.DataFieldTable.State;
          data.rightClickSetting = "VRIManagerForm";
          genericAspect = new ParkingFacilityAspect(data);
          break;

        case "RoadRelation":
          if (aspect.DataFieldTable.Polyline !== "") {
            data.coordinates = aspect.DataFieldTable.Polyline;
            data.relationId = data.id;
            data.referenceName = aspect.DataFieldTable.ReferenceName;
            genericAspect = new RelationAspect(data);
          } else {
            addToMap = false;
          }
          break;

        case "Camera":
          data.url = aspect.DataFieldTable.url;
          genericAspect = new CameraAspect(data);
          break;

        default:
          console.warn("didn't add feature with type ", aspect);
          addToMap = false;
          break;
      }

      if (callback !== null)
        callback.addObject({ genericAspect, aspect, addToMap, toBeRemoved });

      return { genericAspect, aspect, addToMap, toBeRemoved, data };
    },
    /**
     * function to add all the aspects
     * into the Map layer
     */
    addAspects(type, toBeAddedAspectsList) {
      console.log("is dit de functie");
      let ref = this.layerSources[type];
      if (typeof ref === "undefined") {
        this.createLayerWithType(type);
      }
      ref = this.layerSources[type];
      for (const [k, v] of Object.entries(toBeAddedAspectsList)) {
        const a = this.createAspectBasedOnType2(v);
        // this.addObject(a);
        if (a.addToMap == false) continue;

        const mapFeature = a.genericAspect.createFeature();
        mapFeature.setId(k);

        ref.addFeature(mapFeature);
        // this.copyProperties(this.objectHashMap[k], feature);
        this.objectHashMap[k] = mapFeature;
      }
    },
    /**
     * function to remove all the aspects from the Map layer
     * based on the aspect Id
     */
    deleteAspects(type, toBeDeleteAspectsList) {
      const ref = this.layerSources[type];
      if (typeof ref === "undefined") {
        return;
      }

      for (const [k, v] of Object.entries(toBeDeleteAspectsList)) {
        const _id = ref.getFeatureById(k);
        if (_id !== null) {
          ref.removeFeature(_id);
          delete this.objectHashMap[_id];
        }
      }
    },
    categoriesMarkers(markers) {
      console.log("Lorenzo markers", markers);
      const markerImages = this.$store.getters.getCategorieMarkers;

      // the generation of markers in the ThemeList
      this.map
        .getLayers()
        .getArray()
        .filter(layer => layer.get("name") === "CategoriesMarker")
        .forEach(layer => this.map.removeLayer(layer));
      let features = [];
      for (let i = 0; i < markers.length; i++) {
        if (markers[i].Name === "NL") {
          markers.splice(i, 1);
        }
        let item = markers[i];
        let longitude = Number(item.Longitude);
        let latitude = Number(item.Latitude);
        // let categorie = item.LocationTags[Object.keys(item.LocationTags)[0]];
        let listOfTagGroups = [
          "Activities",
          "Service Provider",
          "Bus",
          "Drinking & Nightlife",
          "Eating",
          "POI",
          "Shopping",
          "Sights",
          "Sleeping",
          "Ferry",
          "Entertainment"
        ];
        let categories = Object.keys(item.LocationTags);
        let categorie = "";
        for (
          let firstLoopI = 0;
          firstLoopI < listOfTagGroups.length;
          firstLoopI++
        ) {
          for (
            let secondLoopI = 0;
            secondLoopI < categories.length;
            secondLoopI++
          ) {
            if (listOfTagGroups[firstLoopI] === categories[secondLoopI]) {
              categorie = listOfTagGroups[firstLoopI];
            }
          }
        }

        if (categorie === "") {
          categorie = "POI";
        }

        // !!!data to give with the marker should be put in this var!!!
        let iconFeature = new ol.Feature({
          geometry: new ol.geom.Point(
            ol.proj.transform([longitude, latitude], "EPSG:4326", "EPSG:3857")
          ),
          coordinates: [longitude, latitude],
          data: {
            name: item.Name,
            description: item.Description,
            locationId: item.Id
          }
        });

        let iconStyle = new ol.style.Style({
          image: new ol.style.Icon({
            anchor: [0.5, 1],
            src: markerImages[categorie],
            scale: 0.5
          })
        });

        iconFeature.setStyle(iconStyle);
        features.push(iconFeature);
      }

      let vectorSource = new ol.source.Vector({
        features: features
      });

      let vectorLayer = new ol.layer.Vector({
        source: vectorSource,
        name: "CategoriesMarker"
      });
      vectorLayer.setZIndex(100);
      this.map.addLayer(vectorLayer);

      // !!! uncomment for click event !!!
      let content = document.getElementById('popup-content');
      let closer = document.getElementById('popup-closer');

      let select = new ol.interaction.Select({});
      this.map.addInteraction(select);

      let self = this;
      select.on('select', function(evt) {

        if (evt.target.getFeatures().a.length > 0) {
          console.log("Benjamin evt.target.getFeatures()", evt.target.getFeatures().a[0]);
          let lonlat = evt.target.getFeatures().a[0].N.coordinates;
          let data = evt.target.getFeatures().a[0].N.data;
          console.log("Lorenzo data", data);
          if (data.hasOwnProperty('locationId')) {
            self.popupLocationData = {
              locationId: data.locationId,
              name: data.name,
              description: data.description
            };
            self.getLocationImg(data.locationId);
          } else {
            self.popupImg = false;
          };
          content.innerHTML = '<h3>'+ data.name + '</h3><p>' + data.description + '</p>';

          if (lonlat !== false) {
            self.overlay.setPosition(ol.proj.transform(lonlat, "EPSG:4326", "EPSG:3857"));
          } else {
            self.overlay.setPosition(evt.mapBrowserEvent.coordinate);
            // console.info(evt.mapBrowserEvent.coordinate)
          }

          evt.target.getFeatures().clear();
        }
      });
      closer.onclick = function() {
        self.overlay.setPosition(undefined);
        self.popupImg = false;
        closer.blur();
        return false;
      };
      // to get the mouse to switch to a pointer when hovering over a feature
      this.map.on("pointermove", function(e) {
        let pixel = self.map.getEventPixel(e.originalEvent);
        let hit = self.map.hasFeatureAtPixel(pixel);
        self.map.getViewport().style.cursor = hit ? "pointer" : "";
      });
    },
    getLocationImg(locationId) {
      const payload = {
        LocationId: locationId
      };
      dssRequest.doRequest(
        response => {
          console.log("The generic call getLocationDetails was successfull", response);
          if (response.data.Picture !== null && response.data.Picture !== '' && response.data.Picture !== 'NULL') {
            // this.popupImg = true;
            this.popupImgSrc = response.data.Picture;
          } else {
            this.popupImgSrc = this.defaultImg;
          }

          document.getElementById('popup-img').src = this.popupImgSrc;
        },
        error => {
          console.log("The generic call getLocationDetails was not successfull", error);
        },
        "getLocationDetails",
        locationId,
        payload
      );
    },
    transportVehicleUpdate(markers) {

      const vehicleImages = this.$store.getters.getCategorieMarkers;


      // the generation of markers in the ThemeList
      this.map
        .getLayers()
        .getArray()
        .filter(layer => layer.get("name") === "TransportVehicles")
        .forEach(layer => this.map.removeLayer(layer));
      let features = [];
      for (let i = 0; i < markers.length; i++) {
        let item = markers[i];
        let longitude = Number(item.Longitude);
        let latitude = Number(item.Latitude);
        // let vehicleType = item.DataFieldTable.TransportType;
        let vehicleType = "Service Provider";

        // !!!data to give with the marker should be put in this var!!!
        let iconFeature = new ol.Feature({
          geometry: new ol.geom.Point(
            ol.proj.transform([longitude, latitude], "EPSG:4326", "EPSG:3857")
          )
        });
        let iconStyle = new ol.style.Style({
          image: new ol.style.Icon({
            anchor: [0.5, 1],
            src: vehicleImages[vehicleType],
            scale: 0.5
          })
        });
        iconFeature.setStyle(iconStyle);
        features.push(iconFeature);
      }
      let vectorSource = new ol.source.Vector({
        features: features
      });
      let vectorLayer = new ol.layer.Vector({
        source: vectorSource,
        name: "TransportVehicles"
      });
      this.map.addLayer(vectorLayer);
      // !!! uncomment for click event !!!

      // let select = new ol.interaction.Select({});
      // this.map.addInteraction(select);
      //
      // select.on('select', function(evt) {
      //   if (evt.target.getFeatures().a.length > 0) {
      //     let id = evt.target.getFeatures().a[0].N.elementId;
      //     window.EventBus.fire("selectActivity", id);
      //     evt.target.getFeatures().clear();
      //   }
      // });


      // let self = this;
      // // to get the mouse to switch to a pointer when hovering over a feature
      // this.map.on("pointermove", function(e) {
      //   let pixel = self.map.getEventPixel(e.originalEvent);
      //   let hit = self.map.hasFeatureAtPixel(pixel);
      //   self.map.getViewport().style.cursor = hit ? "pointer" : "";
      // });
    },
    showTours(tours) {
      console.log("showTours being called", tours);
      // the generation of tours polylines in the ThemeList
      this.tours = Object.assign({}, tours);
      let data = Object.keys(tours).map(key => tours[key]);
      this.map
        .getLayers()
        .getArray()
        .filter(layer => layer.get("name") === "Tours")
        .forEach(layer => this.map.removeLayer(layer));

      let features = [];

      for (let i = 0; i < data.length; i++) {
        let item = data[i];
        let activities = Object.keys(item.Activities).map(key => item.Activities[key]);
        let polylineArray = [];
        let travelMode = -1;
        let polylineColor = this.$vuetify.theme.primary;

        activities.forEach(function(activity) {
          if(activity.Type === "Relay") {
            let tmpArray = activity.Aspect.DataFieldTable.Path.split(" ");
            tmpArray.forEach(function(loc) {
              let tmpLocArray = loc.split(",");
              polylineArray.push([Number(tmpLocArray[0]), Number(tmpLocArray[1])]);
            });
            travelMode = Number(activity.Aspect.DataFieldTable.TravelMode);
          }
        });

        switch(travelMode) {
          case 7:
            polylineColor = "#FFA500"; // Orange
            break;
          case 8:
            polylineColor = "#008000"; // Green
            break;
          case 9:
            polylineColor = "#800080"; // Purple
            break;
          case 10:
            polylineColor = "#0000FF"; // Blue
            break;
        }

        let polyline = new ol.geom.LineString(polylineArray);
        // Coordinates need to be in the view's projection, which is
        // 'EPSG:3857' if nothing else is configured for your ol.View instance
        polyline.transform("EPSG:4326", "EPSG:3857");

        // !!!data to give with the marker should be put in this var!!!
        console.log("Benjamin item", item);

        let polylineFeature = new ol.Feature({
          geometry: polyline,
          name: item.TourId,
          coordinates: false,
          data: {
            name: item.EventTranslationName,
            description: item.Description
          }
        });

        let polylineStyle = new ol.style.Style({
          stroke: new ol.style.Stroke({
            color: polylineColor,
            width: 3
          })
        });

        polylineFeature.setStyle(polylineStyle);
        polylineFeature.setId(item.TourId);

        features.push(polylineFeature);
      }

      let vectorSource = new ol.source.Vector({
        features: features
      });

      let vectorLayer = new ol.layer.Vector({
        source: vectorSource,
        name: "Tours"
      });

      vectorLayer.setZIndex(3);
      this.map.addLayer(vectorLayer);

      // let select = new ol.interaction.Select({
      //   layers: [vectorLayer]
      // });
      // this.map.addInteraction(select);
      //
      // let tmpTours = this.tours;
      //
      // select.on('select', function(evt) {
      //   if(evt.selected.length > 0) {
      //     let tourId = evt.selected[0].getId();
      //     let tourName = tmpTours[tourId].Name;
      //
      //     let polylineStyleOnClick = new ol.style.Style({
      //       text: new ol.style.Text({
      //         font: '12px Roboto',
      //         text: tourName,
      //         fill: new ol.style.Fill({
      //           color: '#FF0000'
      //         })
      //       })
      //     });
      //     evt.selected[0].setStyle(polylineStyleOnClick);
      //   }
      //
      //   if(evt.deselected.length > 0) {
      //     let polylineStyleOrigin = new ol.style.Style({
      //       text: new ol.style.Text()
      //     });
      //     evt.deselected[0].setStyle(polylineStyleOrigin);
      //   }
      // });

      // // });
      // let self = this;
      // // to get the mouse to switch to a pointer when hovering over a feature
      // this.map.on("pointermove", function(e) {
      //   let pixel = self.map.getEventPixel(e.originalEvent);
      //   let hit = self.map.hasFeatureAtPixel(pixel);
      //   self.map.getViewport().style.cursor = hit ? "pointer" : "";
      // });
    },
    showRelays(relays) {
      console.log("showRelays being called");
      // the generation of tours polylines in the ThemeList
      this.relays = Object.assign({}, relays);
      let data = Object.keys(relays).map(key => relays[key]);
      this.map
        .getLayers()
        .getArray()
        .filter(layer => layer.get("name") === "Relays")
        .forEach(layer => this.map.removeLayer(layer));

      let features = [];

      for (let i = 0; i < data.length; i++) {
        let relay = data[i];
        let polylineArray = [];
        let travelMode = -1;
        let polylineColor = this.$vuetify.theme.primary;

        // let insideTour = false;
        // let tmpTourArray = Object.keys(this.tours).map(key => this.tours[key]);
        // for(let j=0; j<tmpTourArray.length; j++) {
        //   if(tmpTourArray[j].Activities.hasOwnProperty(relay.EventId)) {
        //     console.log("Relay is inside a tour");
        //     insideTour = true;
        //     break;
        //   }
        // }
        // if(insideTour) continue;

        // if(relay.Aspect.DataFieldTable.TravelMode !== "10") continue;

        let tmpArray = relay.Aspect.DataFieldTable.Path.split(" ");
        tmpArray.forEach(function(loc) {
          let tmpLocArray = loc.split(",");
          polylineArray.push([Number(tmpLocArray[0]), Number(tmpLocArray[1])]);
        });
        travelMode = Number(relay.Aspect.DataFieldTable.TravelMode);

        switch(travelMode) {
          case 7:
            polylineColor = "#FFA500"; // Orange
            break;
          case 8:
            polylineColor = "#008000"; // Green
            break;
          case 9:
            polylineColor = "#800080"; // Purple
            break;
          case 10:
            polylineColor = "#0000FF"; // Blue
            break;
        }

        let polyline = new ol.geom.LineString(polylineArray);
        // Coordinates need to be in the view's projection, which is
        // 'EPSG:3857' if nothing else is configured for your ol.View instance
        polyline.transform("EPSG:4326", "EPSG:3857");

        // !!!data to give with the marker should be put in this var!!!
        let polylineFeature = new ol.Feature({
          geometry: polyline,
          name: relay.EventId,
          coordinates: false,
          data: {
            name: relay.EventTranslationName,
            description: relay.Description
          }
        });

        let polylineStyle = new ol.style.Style({
          stroke: new ol.style.Stroke({
            color: polylineColor,
            width: 3
          })
        });

        polylineFeature.setStyle(polylineStyle);

        features.push(polylineFeature);
      }

      let vectorSource = new ol.source.Vector({
        features: features
      });

      let vectorLayer = new ol.layer.Vector({
        source: vectorSource,
        name: "Relays"
      });

      vectorLayer.setZIndex(2);
      this.map.addLayer(vectorLayer);

      // Select interation
      // let select = new ol.interaction.Select({
      //   layers: [vectorLayer]
      // });
      // this.map.addInteraction(select);
      //
      // let tmpRelays = this.relays;
      //
      // select.on('select', function(evt) {
      //   if(evt.selected.length > 0) {
      //     let relayId = evt.selected[0].getId();
      //     let relayName = tmpRelays[relayId].Name;
      //
      //     let polylineStyleOnClick = new ol.style.Style({
      //       text: new ol.style.Text({
      //         font: '12px Roboto',
      //         text: relayName,
      //         fill: new ol.style.Fill({
      //           color: '#FF0000'
      //         })
      //       })
      //     });
      //     evt.selected[0].setStyle(polylineStyleOnClick);
      //   }
      //
      //   if(evt.deselected.length > 0) {
      //     let polylineStyleOrigin = new ol.style.Style({
      //       text: new ol.style.Text()
      //     });
      //     evt.deselected[0].setStyle(polylineStyleOrigin);
      //   }
      // });

      // // });
      // let self = this;
      // // to get the mouse to switch to a pointer when hovering over a feature
      // this.map.on("pointermove", function(e) {
      //   let pixel = self.map.getEventPixel(e.originalEvent);
      //   let hit = self.map.hasFeatureAtPixel(pixel);
      //   self.map.getViewport().style.cursor = hit ? "pointer" : "";
      // });
    },
    showEventsOfLocation() {
      window.EventBus.fire('showEventsOfLocation', this.popupLocationData);
    }
  }
};
</script>
<style lang="scss">
.map {
  min-height: calc(37.4vh);
  background-color: #acd3de;
}

.settings_css {
  z-index: 5;
}
.settingContentCard {
  max-width: 35em;
  max-height: 20em;
  overflow-x: hidden;
  overflow-y: auto;
}
.buttonClose {
  display: block !important;
}
.ol-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0,0,0,0.2);
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 500px;
}
.ol-popup:after, .ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}
.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}
.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}
.ol-popup-closer:after {
  content: "✖";
}

.calendarImage {
  border-radius: 10px !important;
  width: 13em !important;
  background-position: center center;
  background-size: cover;
}

</style>
